import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Images } from 'constants';

const Carousel = () => {

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        dotsClass: 'custom-dots'
    };

    return (

        <div className='custom-slider mt-1'>
            <div className="custom-b"></div>
            <div className="slider-container">
                <Slider {...settings}>
                    {Array.from({ length: 9 }, (_, i) => {
                        const key = `BANNER_${i + 1}`;
                        return (
                            <div key={key}>
                                <img src={Images[key]} height={92} alt={`Banner ${i + 1}`} />
                            </div>
                        );
                    })}
                </Slider>
            </div>
            <div className="custom-b1 mt-[-6px]"></div>
        </div>

    )
}

export default Carousel